import React, { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { Modal, Button, RedoIcon } from 'examkrackers-components'
import { useDispatch, useSelector } from 'react-redux'
import { getSelectedItems } from 'ducks/selection/selectors'
import { bulkRemoveFlashcardsFromCustomBox } from 'services/FlashcardsService'
import { useHistory } from 'react-router-dom'
import { FetchFlashcardsListPayload } from '../../../types'
import { fetchFlashcardsListRoutine } from '../ducks/actions'
import { pathOr } from 'ramda'
import qs from 'qs'

export const ModalBulkRemoveFromCustomBox = () => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { t } = useTranslation()
  const selectedItems = useSelector(getSelectedItems)
  const {
    location: { search }
  } = useHistory()

  const parsedQuery = qs.parse(search, { ignoreQueryPrefix: true })

  const customBoxId = pathOr('', ['filter', 'custom_box_id'], parsedQuery)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const fetchFlashcards = (payload: FetchFlashcardsListPayload) => {
    dispatch(fetchFlashcardsListRoutine(payload))
  }

  const handleSubmit = e => {
    e.preventDefault()
    setIsLoading(true)

    const handleSuccess = () => {
      fetchFlashcards({ query: search })
      handleClose()
      setIsLoading(false)
    }
    const handleError = () => {
      setIsLoading(false)
    }

    bulkRemoveFlashcardsFromCustomBox({
      box_id: customBoxId,
      ids: selectedItems
    })
      .then(handleSuccess)
      .catch(handleError)
  }

  return (
    <ModalContainer>
      <Button
        size='small'
        color='secondary'
        id='delete-submit'
        isLoading={isLoading}
        disabled={isLoading || selectedItems.length < 1}
        onClick={handleOpen}
        startIcon={<RedoIcon />}
      >
        {t('flashcards.removeFromCustomBox.title')}
      </Button>
      <Modal
        title={t('flashcards.removeFromCustomBox.title')}
        open={open}
        handleClose={handleClose}
      >
        <>
          <div>
            {t('flashcards.removeFromCustomBox.description', {
              count: selectedItems.length
            })}
          </div>
          <ButtonsContainer>
            <Button
              size='small'
              color='secondary'
              id='delete-submit'
              isLoading={isLoading}
              disabled={isLoading}
              onClick={handleSubmit}
            >
              {t('flashcards.removeFromCustomBox.submitCTA')}
            </Button>
            <Button
              size='small'
              id='delete-cancel'
              disabled={isLoading}
              color='tertiary'
              variant='contained'
              onClick={handleClose}
            >
              {t('flashcards.removeFromCustomBox.cancelCTA')}
            </Button>
          </ButtonsContainer>
        </>
      </Modal>
    </ModalContainer>
  )
}

export default ModalBulkRemoveFromCustomBox

const ButtonsContainer = styled.div`
  margin: 30px 0 0;

  button + button {
    margin-left: 10px;
  }
`

const ModalContainer = styled.div`
  line-height: 1;
`
